import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Search from './pages/Search';
import Video from './pages/Video';
import AuthCallback from './pages/AuthCallback';
import Playlists from './pages/Playlists';
import Playlist from './pages/Playlist';
import Modals from './pages/Modals';
import Dashboard from './pages/Dashboard';
import { LeagueProvider } from './context/LeagueContext';
import ErrorBoundary from './components/Common/ErrorBoundary';

function App() {
  const location = useLocation()
  const previousLocation = location.state?.previousLocation
  return (
    <LeagueProvider>
      <ErrorBoundary>
        <Routes location={previousLocation || location}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/search" element={<Search />} />
          <Route path="/playlists" element={<Playlists />} />
          <Route path='/playlists/:id' element={<Playlist />}/>
          <Route path="/video/:hash" element={<Video />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        { previousLocation &&
          <Routes>
            <Route path="/modals/:modalId" element={<Modals />}/>
            <Route path="/modals/:modalId/:playlistId" element={<Modals />}/>
          </Routes>
        }
      </ErrorBoundary>
    </LeagueProvider>
  );
}

export default App;
